import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { UserService } from '@shared/services/user.service';
import { Observable, of } from 'rxjs';
import { RxStomp } from '@stomp/rx-stomp';
import { InjectableRxStompConfig } from '@stomp/ng2-stompjs';
import { QrCodeService } from '@shared/services/qr-code.service';

export const lcoRxStompConfig: InjectableRxStompConfig = {
  brokerURL: environment.websocketUrl,
  heartbeatIncoming: 0, // Typical value 0 - disabled
  heartbeatOutgoing: 20000, // Typical value 20000 - every 20 seconds
  reconnectDelay: 20000,
  debug: (msg: string): void => {
    console.log(msg);
  },
};

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {
  env = environment;
  rxStomp: RxStomp|null = null;

  get lcoHeaders() {
    return {
      'login': this.userService.userMobilePhone || '',
      'LCO-AUTH-TOKEN': this.userService.token || ''
    };
  }

  constructor(private userService: UserService,
              private qrCodeService: QrCodeService) {
  }

  get rxNowPlayingSong$(): Observable<any> {
    if (!this.rxStomp) {
      return of(true);
    }

    // todo detect music ON at location
    // const url = `/topic/rx_now_playing_${this.qrCodeService.storeCode}`;
    const url = `/topic/rx_now_playing_LABQSR`;
    return this.rxStomp.watch(url, this.lcoHeaders);
  }

  orderStatus$(phoneNumber: string): Observable<any> {
    if (!this.rxStomp) {
      return of(true);
    }

    const url = `/topic/lco_${phoneNumber}`;
    return this.rxStomp.watch(url, this.lcoHeaders);
  }

  setup() {
    this.rxStomp = new RxStomp();
    this.rxStomp.configure({
      brokerURL: this.env.websocketUrl,
      connectHeaders: this.lcoHeaders,
      heartbeatIncoming: 0,
      heartbeatOutgoing: 0,
      reconnectDelay: 10000,
      debug: (msg: string): void => {
        // console.log(new Date(), msg);
      },
    });
    this.rxStomp.activate();
  }
}
